<template>
  <div>
    <v-container class="content-wrapper" fluid id="add-hosting-tab">
      <v-row justify="center" align="center">
        <v-col cols="12" lg="10">
          <v-card
            class="pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <v-row align="center" class="mb-10">
              <v-col cols="12" md="auto">
                <v-btn
                  v-if="$store.getters.roles === 'super-admin'"
                  depressed
                  rounded
                  medium
                  color="primary200"
                  class="white--text font-weight-bold"
                  :to="{ name: 'HostingInstitutions' }"
                >
                  <v-icon color="black" small class="mr-2">
                    mdi-arrow-left
                  </v-icon>
                  Back to Hosting Institutions
                </v-btn>
                <v-btn
                  v-else
                  depressed
                  rounded
                  medium
                  color="primary200"
                  class="white--text font-weight-bold"
                  :to="{ name: 'Dashboard' }"
                >
                  <v-icon color="black" small class="mr-2">
                    mdi-arrow-left
                  </v-icon>
                  Back to Dashboard
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" class="neutral--text text-semi-bold mb-4">
                {{ $t('add-equipment-info') }}
              </v-col>
            </v-row>
            <div>
              <h5>
                {{ $t('your-progress') }}
              </h5>
              <label class="text-bold primary300--text"
                >{{ tab + 1 }}/{{ totalTabs }} {{ $t('to-complete') }}</label
              >
              <v-progress-linear
                v-model="progress"
                color="primary300"
                id="equipment-progress-bar"
                class="mb-4 mt-4"
                height="25"
              ></v-progress-linear>
            </div>

            <!-- Tabs for Add Hosting -->
            <v-tabs
              v-model="tab"
              show-arrows
              active-class="primary200--text"
              class="disable-transition"
            >
              <v-tabs-slider color="primary200"></v-tabs-slider>
              <v-tab>{{ $t('basic') }}</v-tab>
              <v-tab>{{ $t('detailed') }}</v-tab>
              <v-tab>{{ $t('classification') }}</v-tab>
              <v-tab>{{ $t('contact') }}</v-tab>
              <v-tab>{{ $t('location') }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item :transition="false" :reverse-transition="false" :key="0">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddHostingBasicInfo
                      @tab="changeTab"
                      @hostingProviderInfo="handleHostingBasicInfo"
                    ></AddHostingBasicInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="1">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddHostingDetailedInfo
                      @tab="changeTab"
                      @hostingDetailedInfo="handleHostingDetailedInfo"
                    ></AddHostingDetailedInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="2">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddHostingClassification
                      @tab="changeTab"
                      @hostingClassificationInfo="handleHostingClassificationInfo"
                    ></AddHostingClassification>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="3">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddHostingContactInfo
                      @tab="changeTab"
                      @hostingContactInfo="handleHostingContactInfo"
                    ></AddHostingContactInfo>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="4">
                <v-row class="mt-10 mb-5">
                  <v-col cols="12">
                    <AddHostingLocationInfo
                      @tab="changeTab"
                      @hostingLocationInfo="handleHostingLocationInfo"
                    ></AddHostingLocationInfo>
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center mb-10" v-if="dataForPayload">
                  <v-btn
                    depressed
                    rounded
                    x-large
                    width="450px"
                    color="black"
                    @click="submit"
                    class="white--text font-weight-bold"
                    >{{ $t('submit') }}
                  </v-btn>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AddHostingBasicInfo from './AddHostingBasicInfo.vue';
import AddHostingDetailedInfo from './AddHostingDetailedInfo.vue';
import AddHostingClassification from './AddHostingClassification.vue';
import AddHostingContactInfo from './AddHostingContactInfo.vue';
import AddHostingLocationInfo from './AddHostingLocationInfo.vue';
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus.js';

export default {
  name: 'AddHostingInstitution',
  mixins: [util],
  components: {
    AddHostingBasicInfo,
    AddHostingDetailedInfo,
    AddHostingClassification,
    AddHostingContactInfo,
    AddHostingLocationInfo,
  },
  data() {
    return {
      tab: null,
      totalTabs: 5,
      hostingProviderInfo: Object,
      hostingDetailedInfo: Object,
      hostingClassificationInfo: Object,
      hostingContactInfo: Object,
      hostingLocationInfo: Object,
    };
  },
  computed: {
    progress() {
      return ((this.tab + 1) / this.totalTabs) * 100;
    },
    dataForPayload() {
      return Object.keys(this.hostingLocationInfo).length > 0;
    },
  },
  methods: {
    changeTab(childTab) {
      console.log('Tab changed');

      this.tab = childTab;
    },
    handleHostingBasicInfo(data) {
      this.hostingProviderInfo = data;
    },
    handleHostingDetailedInfo(data) {
      this.hostingDetailedInfo = data;
    },
    handleHostingClassificationInfo(data) {
      this.hostingClassificationInfo = data;
    },
    handleHostingContactInfo(data) {
      this.hostingContactInfo = data;
    },
    handleHostingLocationInfo(data) {
      this.hostingLocationInfo = data;
    },
    submit() {
      const payload = {
        ...this.hostingProviderInfo,
        ...this.hostingDetailedInfo,
        ...this.hostingClassificationInfo,
        ...this.hostingContactInfo,
        ...this.hostingLocationInfo,
      };

      console.log('Payload Body', payload);

      this.axios
        .post('/api/v1/hosting-institutions', payload)
        .then(response => {
          console.log('Success:', response.data);
          EventBus.$emit('snackbar', {
            text: 'Hosting Institution Created Successfully',
            color: 'primary200',
          });

          const firstTime = sessionStorage.getItem('firstTime');

          if (!firstTime) {
            this.$router.push({ name: 'HostingInstitutions' });
          } else {
            const representativeId = Number(localStorage.getItem('representativeId'));
            sessionStorage.setItem('representativeId', representativeId);

            this.$router.push({ name: 'Dashboard' }).then(() => {
              this.$router.go();
            });
          }
        })
        .catch(error => {
          console.error('Error:', error);
        });
    },
  },
};
</script>
